import React from 'react';
import { Hero } from '../components/Hero';
import { SalesLetter } from '../components/SalesLetter';
import { PreviewCarousel } from '../components/PreviewCarousel';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { UpsellSection } from '../components/UpsellSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-379">
      <header className="bg-white border-b border-slate-200 py-4 sticky top-0 z-40 shadow-sm" data-id="element-380">
        <div className="max-w-6xl mx-auto px-4 flex justify-between items-center" data-id="element-381">
          <div className="font-black text-2xl tracking-tight text-slate-900" data-id="element-382">
            SIC<span className="text-blue-600" data-id="element-383">360</span>
          </div>
          <button onClick={() => document.getElementById('purchase')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors" data-id="element-384">
            Comprar Ahora
          </button>
        </div>
      </header>

      <main data-id="element-385">
        <Hero data-id="element-386" />
        <SalesLetter data-id="element-387" />
        <PreviewCarousel data-id="element-388" />
        <BonusSection data-id="element-389" />
        <PricingSection data-id="element-390" />
        <UpsellSection data-id="element-391" />
        <GuaranteeSection data-id="element-392" />
        <TestimonialsSection data-id="element-393" />
        <FAQSection data-id="element-394" />
      </main>

      <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm" data-id="element-395">
        <div className="max-w-6xl mx-auto px-4" data-id="element-396">
          <p className="mb-4 font-bold text-white text-lg" data-id="element-397">SIC 360</p>
          <p data-id="element-398">© {new Date().getFullYear()} Todos los derechos reservados.</p>
          <p className="mt-2" data-id="element-399">Hecho con ❤️ para la docencia argentina.</p>
        </div>
      </footer>

      <PurchaseNotification data-id="element-400" />
    </div>;
}